{
  "header": {
    "title": "About us",
    "subtitle": "Scalefield is a modern, agile PostgreSQL hosting platform",
    "located": "Located in <strong>Austria, Europe</strong>",
    "description": "It is designed to help you storing your data in the most effective way possible. By offering powerful and GDPR safe infrastructure, Scalefield gives you the opportunity to securely store your most valuable asset - your data! You can now easily host PostgreSQL clusters within Scalefield - fully flexible, scalable and reliable."
  },
  "about_us": {
    "top_text": "In comparison to others, Scalefield supports a wide range of PostgreSQL extensions (see full list here), gives you access to pre-loaded OSM data and allows you a way more flexible PostgreSQL configuration.",
    "bottom_text": "Additionally, we offer you way more than hosting with Scalefield, we offer you the full PostgreSQL service range, if needed: \nFrom migration to PostgreSQL and providing PostgreSQL as an user-friendly and highly secure enterprise edition, to 24/7 support, consulting and training.",
    "we_are_here_for_you": "<strong>We are </strong>here for you."
  },
  "our_values": {
    "title": "Our Values",
    "service_1": {
      "title": "Highly secure & GDPR safe",
      "text": "Our servers are located in AUSTRIA, Europe. So you do not need to worry about GDPR, the <i>CLOUD Act</i> and your data leaking to the US government. Your data is safe with us."
    },
    "service_2": {
      "title": "High performance",
      "text": "As Scalefield consists of a powerful infrastructure, paired with super fast PostgreSQL backend stored Kubernetes, accessing your data is quick and easy.\n"
    },
    "service_3": {
      "title": "Cost effective",
      "text": "You will pay for what you need and get what you have paid for. No extra costs, nothing added on top."
    },
    "service_4": {
      "title": "Uncomplicated",
      "text": "All you have to do is login and set up a cluster. Check out the demo video to see how easy hosting with Scalefield is."
    },
    "service_5": {
      "title": "Personal contact",
      "text": "We are real developers. You will not talk to Alexa - our consultants are named Armin, Haris, Kieran. You can contact us whenever you want - we get back to you."
    },
    "service_6": {
      "title": "Full service",
      "text": "Scalefield is just the tip of the iceberg. If you want to migrate to PostgreSQL, implement an PostgreSQL enterprise distribution or need PostgreSQL support, consulting or training - we are here for you."
    }
  },
  "our_mission": {
    "title": "Our Mission",
    "text": "We want to make managing and storing your data as simple, uncomplicated, secure, cost-effective and innovative as possible for you. <br>Because <i>only then</i>, you can generate the optimal benefit from your most valuable asset - your data."
  },
  "statistics": {
    "title": "Scalefield is developed with \uD83D\uDC97 by CYBERTEC",
    "description": "CYBERTEC is a worldwide leading IT company, offering PostgreSQL database and data science services.<br>Our international experts, just like the whole company, have been in the database business since 2000.",
    "million": "{{count}}M+",
    "offices": "offices",
    "clients": "clients",
    "projects": "projects",
    "lines_of_code": "Lines of code",
    "legend": {
      "our_headquarter_is_located": "Our headquarter is located in",
      "wollersdorf_austria": "Wöllersdorf,<br>Austria",
      "with_further_locations_in": "with further locations in",
      "estonia": "Estonia",
      "switzerland": "Switzerland",
      "poland": "Poland",
      "south_africa": "South Africa",
      "mauritius": "Mauritius",
      "and": "and",
      "uruguay": "Uruguay"
    }
  },
  "services": {
    "title": "CYBERTEC offers full PostgreSQL services",
    "service_title_1": "Migration to PostgreSQL",
    "service_text_1": "You can either use our tool <i>CYBERTEC Migrator</i> or check out our migration services",
    "service_title_2": "PostgreSQL distribution for enterprises",
    "service_text_2": "We have developed a highly secure enterprise edition of PostgreSQL called <i>PGEE</i>",
    "service_title_3": "24/7 PostgreSQL Support",
    "service_text_3": "Our experts have over 20 years relevant database experience in the PostgreSQL environment and help whenever needed – quickly and reliably – and 24/7!",
    "service_title_4": "PostgreSQL Consulting",
    "service_text_4": "We have the best of the best. Our experts have always been actively contributing to PostgreSQL and know more than anyone else about their one and only database",
    "service_title_5": "PostgreSQL Training",
    "service_text_5": "We offer a wide range of PostgreSQL online training as well as courses in our offices or at your location. Make sure to also check out our Data Science and Spatial Data classes!",
    "service_title_6": "Working with you",
    "service_text_6": "If you want to use Scalefield on premise and operate within your own environment - contact us!"
  },
  "offices": {
    "title": "Our offices",
    "item_1": {
      "title": "International (HQ)",
      "line_1": "Cybertec Schönig & Schönig GmbH",
      "line_2": "Römerstraße 19",
      "line_3": "2752 Wöllersdorf",
      "line_4": "Austria",
      "line_5": "+43 (0)2622 93022",
      "line_6": "sales@cybertec-postgresql.com"
    },
    "item_2": {
      "title": "Switzerland",
      "line_1": "Cybertec PG Database Services Switzerland GmbH",
      "line_2": "Bahnhofstraße 10",
      "line_3": " 8001 Zürich",
      "line_4": "Switzerland",
      "line_5": "+41 43 456 2684",
      "line_6": "swiss@cybertec-postgresql.com"
    },
    "item_3": {
      "title": "Nordic",
      "line_1": "Cybertec Nordic OÜ Fahle Office",
      "line_2": "Tartu mnt 84a-M302",
      "line_3": "10112 Tallinn",
      "line_4": "Estonia",
      "line_5": "",
      "line_6": ""
    },
    "item_4": {
      "title": "South America",
      "line_1": "Cybertec PG Database Services",
      "line_2": "South America S.A.",
      "line_3": "Misiones 1486 oficina 301",
      "line_4": "11000 Montevideo",
      "line_5": "Uruguay",
      "line_6": "latam@cybertec-postgresql.com"
    },
    "item_5": {
      "title": "South Africa",
      "line_1": "No. 26, Cambridge Office Park",
      "line_2": "5 Bauhinia Street, Highveld Techno Park",
      "line_3": "0046 Centurion",
      "line_4": "South Africa",
      "line_5": "+27(0)012 880 3270",
      "line_6": "africa@cybertec-postgresql.com"
    }
  }
}
